
import React, { PropTypes } from 'react';
import DataService from '../../lib/DataService';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import BarChartView from '../share/BarChartView';
import SharedTools from '../../lib/SharedTools';
import { Spin } from 'antd';
import { hashHistory } from 'react-router';

import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Cell, Text, Label, LabelList } from 'recharts';

export default class ClassUsageReportPage extends React.Component {

  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      currentRole: CurrentRoleStore.getCurrentRole(),
      schoolId: props.params.schoolId,
      classId: props.params.classId,
      className: props.location.query.className,
      year: props.location.query.year ? Number(props.location.query.year) : new Date().getFullYear(),
      month: props.location.query.month ? Number(props.location.query.month) : new Date().getMonth() + 1,
      type: '',
      loadding: true,
      infos: []
    };
    // bind this
    // this.selectGrade = this.selectGrade.bind(this);
    this.changeMonth = this.changeMonth.bind(this);
    this.getClassUsageData = this.getClassUsageData.bind(this);
  }

  componentDidMount() {
    let data = {
      class_id: this.state.classId,
      year: this.state.year,
      month: this.state.month
    }
    this.getClassUsageData(data);
  }

  changeMonth(e) {
    let month, year;
    if (e.currentTarget.dataset.key == 'add') {
      month = this.state.month == 12 ? 1 : (this.state.month + 1);
      year = this.state.month == 12 ? (this.state.year + 1) : this.state.year;
    } else {
      month = this.state.month == 1 ? 12 : (this.state.month - 1);
      year = this.state.month == 1 ? (this.state.year - 1) : this.state.year;
    }
    let data = {
      class_id: this.state.classId,
      year: year,
      month: month
    };
    this.getClassUsageData(data);
    this.setState({
      year: year,
      month: month,
    })
  }

  getClassUsageData(data) {
    let that = this;
    DataService.getClassUsageData(data).then(res => {
      this.setState({
        infos: res,
        loadding: false
      })
    }).then((err) => {
      if (err) {
        console.log(err);
      }
      that.setState({
        loadding: false
      })
    })
  }

  render() {
    let { className } = this.state;
    return (
      <div className="usage-report-page" ref="usageReport">
        {this.state.loadding &&
          <div className="spinner">
            <Spin size="large" />
          </div>
        }

        {!this.state.loadding &&
          <div>
            {className ? <div className="grade-list clearfix">
              <div className="grade col-1">
                <span className="grade-name selected" >{className}</span>
              </div>
            </div> : ''}

            <div className="current-month">
              <span className="left-icon" onClick={this.changeMonth} data-key="subtract"></span>
              <span className="month">{SharedTools.monthToString(this.state.month)}月<span className="month-detail">({this.state.year}.{this.state.month}.1 - {this.state.year}.{this.state.month}.{SharedTools.formatDate(this.state.year, this.state.month)})</span></span>
              <span className="right-icon" onClick={(this.state.year == (new Date().getFullYear()) && this.state.month == (new Date().getMonth() + 1)) ? null : this.changeMonth} data-key="add"></span>
            </div>

            <div className="title">
              <div className="point post">新鲜事</div>
              <div className="point photo">照片</div>
              <div className="point video">视频</div>
            </div>

            <div className="chart-container">
              <BarChart width={550} height={300} data={this.state.infos}
                margin={{ top: 20, right: 0, left: 0, bottom: 0 }}>
                <YAxis type="number" tick={{ fontSize: '13px' }} />
                <XAxis dataKey="name" type="category" tick={{ fontSize: '12px' }} />
                <Bar dataKey="post_count" label={{ fill: '#999999', fontSize: 14, position: 'top', dx: 10, dy: -5 }} barSize={20} >
                  {
                    this.state.infos.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill="#FFE247" />
                    ))
                  }
                </Bar>
                <Bar dataKey="photo_count" label={{ fill: '#999999', fontSize: 14, position: 'top', dx: 10, dy: -5 }} barSize={20}>
                  {
                    this.state.infos.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill="orange" />
                    ))
                  }
                </Bar>
                <Bar dataKey="video_count" label={{ fill: '#999999', fontSize: 14, position: 'top', dx: 10, dy: -5 }} barSize={20}>
                  {
                    this.state.infos.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill="#7D93DC" />
                    ))
                  }
                </Bar>
              </BarChart>
            </div>
          </div>
        }
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/schooladmin/ClassUsageReportPage.jsx